export default __webpack_public_path__ + "locales/pl/HotkeysPanel.json?hash=7502f7add3c4f0916fbd42bd6b6d0ba3";